/**
 * Respawn13 — Featured-row mobile carousel
 * Each card is full-width on mobile; prev/next arrows scroll one card at a time.
 * Arrows hide automatically when the row fits or when at edge.
 */
(function () {
  "use strict";

  function init(root) {
    var grid = root.querySelector("[data-featured-grid]");
    var prev = root.querySelector("[data-featured-prev]");
    var next = root.querySelector("[data-featured-next]");
    if (!grid || !prev || !next) return;

    function cardWidth() {
      var first = grid.querySelector(".featured-row__cell");
      if (!first) return 0;
      var styles = window.getComputedStyle(grid);
      var gap = parseInt(styles.columnGap || styles.gap || "0", 10);
      return first.getBoundingClientRect().width + gap;
    }

    function update() {
      var atStart = grid.scrollLeft <= 4;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.style.opacity = atStart ? "0.4" : "1";
      next.style.opacity = atEnd ? "0.4" : "1";
    }

    prev.addEventListener("click", function () {
      grid.scrollBy({ left: -cardWidth(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      grid.scrollBy({ left: cardWidth(), behavior: "smooth" });
    });
    grid.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    update();
  }

  function bootAll() {
    document.querySelectorAll("[data-featured-row]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll("[data-featured-row]").forEach(init);
    }
  });
})();
